module.exports = __webpack_public_path__ + "static/cimplify-white-logo-0813f5e020d66b432be765026ac7d8ea.svg";